// Glossary of defined terms (S5): A–Z rail, search, the abbreviation filter and the definition with its usage; typed search params drive every filter.
import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import { z } from "zod";

import { optionalString, optionalBoolean } from "@/app/search";
import { GlossaryScreen } from "@/features/vocabulary/glossary/GlossaryScreen";
import type { GlossarySearchPatch } from "@/features/vocabulary/glossary/search";

const searchSchema = z.object({
  doc: optionalString(),
  q: optionalString(),
  letter: optionalString(),
  abbr: optionalBoolean(),
  term: optionalString(),
});

export const Route = createFileRoute("/_app/$region/glossary")({
  validateSearch: searchSchema,
  staticData: { crumb: "Glossary" },
  component: GlossaryRoute,
});

function GlossaryRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const update = useCallback(
    (patch: GlossarySearchPatch) => {
      void navigate({ search: (previous) => ({ ...previous, ...patch }), replace: true });
    },
    [navigate],
  );
  return <GlossaryScreen search={search} onSearchChange={update} />;
}
